import { defineComponent as _defineComponent } from 'vue'
import SharedTrip from "@/models/dto/SharedTrip";
import {URMRoleKey, URMRoles} from "@/models/dto/userRoleManagement";
import {findBestRoleForCustomer, noTeamRoleDisplayText} from "@/utils/urmUtils";
import {computed} from "vue";
import ContactListItemTag from "@/components/Contact/ContactListItemTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SharedTripUserType',
  props: {
    row: null
  },
  setup(__props: any) {

const props = __props as {
  row: SharedTrip,
};



const primaryRoleLabel = computed(() => findBestRoleForCustomer(props.row.roles, [URMRoles.TripAuthorizedUser, URMRoles.TripViewOnly])?.label || noTeamRoleDisplayText)
const hasTripContactRole = computed(() => props.row.roles.includes(URMRoleKey.TripContact));
const hasTripEditorRole = computed(() => props.row.roles.includes(URMRoleKey.TripEditor));

return { __sfc: true,props, primaryRoleLabel, hasTripContactRole, hasTripEditorRole, URMRoles, ContactListItemTag }
}

})